module.exports = __webpack_public_path__ + "img/kommune-534.09123d40.svg";